import "./LanguagesGallery.scss"
import React from "react"
import Image from "gatsby-image"
import { Container, Row, Col } from "reactstrap"

import {
  extractAltTag
} from "@utils/utils"

const LanguagesGallery = ({ images, ...props }) => (
  <Container id="language-gallery" className="mt-n5" {...props}>
    <Row className="align-items-center">
      <Col xs={3} className="p-4">
        <Image className="mr-auto" fluid={images[0]} alt={extractAltTag(images[0].src, 'Sprachen')} />
      </Col>
      <Col xs={3} className="p-4">
        <Image className="m-auto" fluid={images[1]} alt={extractAltTag(images[1].src, 'Sprachen')} />
      </Col>
      <Col xs={3} className="p-4">
        <Image className="m-auto" fluid={images[2]} alt={extractAltTag(images[2].src, 'Sprachen')} />
      </Col>
      <Col xs={3} className="p-4">
        <Image className="ml-auto" fluid={images[3]} alt={extractAltTag(images[3].src, 'Sprachen')} />
      </Col>
    </Row>
    <Row className="align-items-center">
      <Col xs={4} className="p-4">
        <Image className="mr-auto" fluid={images[4]} alt={extractAltTag(images[4].src, 'Sprachen')} />
      </Col>
      <Col  xs={4} className="p-4">
        <Image className="m-auto" fluid={images[5]} alt={extractAltTag(images[5].src, 'Sprachen')} />
      </Col>
      <Col  xs={4} className="p-4">
        <Image className="ml-auto" fluid={images[6]} alt={extractAltTag(images[6].src, 'Sprachen')} />
      </Col>
    </Row>
    <Row className="align-items-center">
      <Col  xs={4} className="p-4">
        <Image className="mr-auto" fluid={images[7]} alt={extractAltTag(images[7].src, 'Sprachen')} />
      </Col>
      <Col  xs={4} className="p-4">
        <Image className="m-auto" fluid={images[8]} alt={extractAltTag(images[8].src, 'Sprachen')} />
      </Col>
      <Col  xs={4} className="p-4">
        <Image className="ml-auto"  fluid={images[9]} alt={extractAltTag(images[9].src, 'Sprachen')} />
      </Col>
    </Row>
  </Container>
)

export default LanguagesGallery
